import {fetcher} from '@/src/shared/lib/fetcher/fetcher'
import {Chat, MessageDetails} from '@/src/services/MessagesService/types'

const API_URL = process.env.NEXT_PUBLIC_API_URL

export const getLastMessages = () => {
  return fetcher<{chatList: Chat[]}>({
    url: `${API_URL}/messages/last`,
    method: 'GET',
    isAuth: true,
  })
}

export const getChatDetails = (chatId: string) => {
  return fetcher<MessageDetails>({
    url: `${API_URL}/messages/${chatId}`,
    method: 'GET',
    isAuth: true,
  })
}

export const sendMessage = (content: string, receiverId: string) => {
  return fetcher<MessageDetails>({
    url: `${API_URL}/messages/send`,
    method: 'POST',
    isAuth: true,
    body: {
      content,
      receiverId,
    },
  })
}

export const updateUnread = (unreadMessageIds: string[]) => {
  return fetcher<MessageDetails>({
    url: `${API_URL}/messages/update-read`,
    method: 'PUT',
    isAuth: true,
    body: unreadMessageIds,
  })
}

export const blockUser = async (chatId: string) => {
  return fetcher<{result: boolean}>({
    url: `${API_URL}/messages/block`,
    method: 'POST',
    isAuth: true,
    body: {chatId},
  })
}

export const unBlockUser = async (chatId: string) => {
  return fetcher<{result: boolean}>({
    url: `${API_URL}/messages/unblock`,
    method: 'POST',
    isAuth: true,
    body: {chatId},
  })
}

export const getUnreadMessagesCount = async () => {
  return fetcher<number>({
    url: `${API_URL}/messages/unread-count`,
    method: 'GET',
    isAuth: true,
  })
}
